// extracted by mini-css-extract-plugin
export var drawerPaper = "_2h-0";
export var itemCard = "_2h-1";
export var itemImage = "_2h-2";